jQuery( document ).ready(function( $ ) {
  $(".woocommerce-store-notice__dismiss-link").on("click", function() { 
    $("body").removeClass("notice_banner--show").addClass("notice_banner--hidden");
  });
});

